import { $ } from "@/common/Axios";

export default {
  /**
   * 授课老师
   */
  teacher_syncAdminInfo: {
    /*
     * 同步管理员信息
     */
    put: (p, c) => $.put("/api/cms/resource/teacher/syncAdminInfo", p, c),
  },
  teacher: {
    /*
     * 添加
     * teacher  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/teacher", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/teacher", p, c),
  },
  teacher_listSimple: {
    /*
     * 简易列表
     * type 课程类型：继教院 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/teacher/listSimple", p, c),
  },
  teacher_listForContinue: {
    /*
     * 继教院授课老师列表
     */
    get: (p, c) => $.get("/api/cms/resource/teacher/listForContinue", p, c),
  },
  teacher_getCurrentTeacherId: {
    /*
     * 获取当前登录用户的授课老师id
     */
    get: (p, c) => $.get("/api/cms/resource/teacher/getCurrentTeacherId", p, c),
  },

  /**
   * 习题
   */
  subject_updateChapterSubject: {
    /*
     * 编辑章节习题
     * subject  ( query required)
     */
    put: (p, c) =>
      $.put("/api/cms/resource/subject/updateChapterSubject", p, c),
  },
  subject: {
    /*
     * 添加
     * subject  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/subject", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/subject", p, c),
  },
  subject_uploadSubjectByExcel: {
    /*
     * 上传习题
     * type 类型：章节练习，全真模拟 (string query required)
     * belongId 知识点id (integer query required)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/subject/uploadSubjectByExcel", p, c),
  },
  subject_uploadChapterSubject: {
    /*
     * 上传章节习题-(Word)
     * type 类型：章节练习，直播课课后练习 (string query required)
     * belongId 知识点id (integer query required)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/subject/uploadChapterSubject", p, c),
  },
  subject_uploadByWord: {
    /*
     * 上传习题-Word
     * type 类型：章节练习，历年真题、摸底考试、模拟测试、全真模拟 (string query required)
     * belongId 归属id (integer query required)
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/cms/resource/subject/uploadByWord", p, c),
  },
  subject_uploadByExcel: {
    /*
     * 上传习题-Excel
     * type 类型：章节练习，历年真题、摸底考试、模拟测试、全真模拟 (string query required)
     * belongId 归属id (integer query required)
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/cms/resource/subject/uploadByExcel", p, c),
  },
  subject_sortOrderSubject: {
    /*
     * 顺序练习重新排序
     */
    post: (p, c) => $.post("/api/cms/resource/subject/sortOrderSubject", p, c),
  },
  subject_refreshOrderSubject: {
    /*
     * 刷新顺序练习
     */
    post: (p, c) =>
      $.post("/api/cms/resource/subject/refreshOrderSubject", p, c),
  },
  subject_list: {
    /*
     * 章节练习习题列表
     * knowledgeId 知识点id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/subject/list", p, c),
  },
  subject_listSortSubject: {
    /*
     * 顺序练习习题列表
     */
    get: (p, c) => $.get("/api/cms/resource/subject/listSortSubject", p, c),
  },
  subject_listCardSubjectForClient: {
    /*
     * 答题卡习题列表
     * paperId 试卷id (integer query required)
     * exerciseId 练习id,解析的时候一定要传 (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/listCardSubjectForClient", p, c),
  },
  subject_listByBelongId: {
    /*
     * 根据归属id获取习题列表
     * belongId 归属id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/subject/listByBelongId", p, c),
  },
  subject_getOrderSubjectForClient: {
    /*
     * 获取顺序习题
     * id 习题id (integer query required)
     * exerciseId 练习id,解析的时候一定要传 (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/getOrderSubjectForClient", p, c),
  },
  subject_getContentByContentId: {
    /*
     * 根据内容id获取内容
     * id 内容id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/getContentByContentId", p, c),
  },
  subject_exportSortSubject: {
    /*
     * 导出顺序联系习题列表
     */
    get: (p, c) => $.get("/api/cms/resource/subject/exportSortSubject", p, c),
  },
  subject_downloadMouldExcelSubject: {
    /*
     * 下载Excel习题模版
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/downloadMouldExcelSubject", p, c),
  },
  subject_downloadExcelModule: {
    /*
     * 下载Excel习题模版
     */
    get: (p, c) => $.get("/api/cms/resource/subject/downloadExcelModule", p, c),
  },
  subject_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/subject/details", p, c),
  },
  subject_detailsByPaperId: {
    /*
     * 试卷习题详情
     * paperId 试卷id (integer query required)
     * userId 用户id (integer query )
     * exerciseId 练习id (integer query )
     */
    get: (p, c) => $.get("/api/cms/resource/subject/detailsByPaperId", p, c),
  },
  subject_detailsByPaperForClient: {
    /*
     * C端试卷习题详情
     * paperId 试卷id (integer query required)
     * type 类型：测试，考试，解析 (string query required)
     * exerciseId 练习id,解析的时候一定要传 (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/detailsByPaperForClient", p, c),
  },
  subject_detailChapterSubject: {
    /*
     * 章节习题详情
     * id 习题id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/detailChapterSubject", p, c),
  },
  subject_countSortSubject: {
    /*
     * 顺序练习习题数量
     * paperId 顺序练习试卷id (integer query required)
     * type 类型： 有内容、无内容 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/subject/countSortSubject", p, c),
  },
  subject_clearByBelongId: {
    /*
     * 根据归属id清除
     * belongId 归属id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/resource/subject/clearByBelongId", p, c),
  },

  /**
   * 学校课表项
   */
  siteTableItem_updateSchoolroom: {
    /*
     * 更新教室
     * id 课表id (integer query required)
     * schoolroomId 教室id (integer query required)
     * updateType 类型：全部、当前 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/resource/siteTableItem/updateSchoolroom", p, c),
  },
  siteTableItem: {
    /*
     * 添加
     * tableItem  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/siteTableItem", p, c),

    /*
     * 删除
     * id id (integer query required)
     * removeType 删除类型：当前，全部 (string query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/siteTableItem", p, c),
  },
  siteTableItem_confirm: {
    /*
     * 确认
     * siteId 学校id (integer query required)
     * teacherId 老师id (integer query required)
     * timeRange 时间 (string query required)
     */
    post: (p, c) => $.post("/api/cms/resource/siteTableItem/confirm", p, c),
  },
  siteTableItem_tableInfo: {
    /*
     * 排课信息
     * siteId 学校id (integer query required)
     * teacherId 老师id (integer query required)
     * timeRange 时间 (string query required)
     * type 类型：标准，实时 (string query required)
     * start 开始时间，类型为实时的时候启用 (string query )
     * end 结束时间，类型为实时的时候启用 (string query )
     */
    get: (p, c) => $.get("/api/cms/resource/siteTableItem/tableInfo", p, c),
  },
  siteTableItem_listSimpleForTeacher: {
    /*
     * 获取学校-教学计划简易列表
     * attendanceDate 考勤日期 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/siteTableItem/listSimpleForTeacher", p, c),
  },
  siteTableItem_getStudentTableItem: {
    /*
     * 获取学生课表(班主任视图)
     * attendanceDate 考勤日期 (string query required)
     * timeType 时间类型：上午、下午、晚上 (string query required)
     * siteId 学校id (integer query required)
     * classRoomId 班级id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/resource/siteTableItem/getStudentTableItem", p, c),
  },

  /**
   * 知识点
   */
  knowledge_batchAble: {
    /*
     * 批量启用禁用
     * ids 知识点id (array query required)
     * ableStatus 启用状态：启用，禁用 (string query required)
     */
    put: (p, c) => $.put("/api/cms/resource/knowledge/batchAble", p, c),
  },
  knowledge: {
    /*
     * 添加
     * knowledge  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/knowledge", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/knowledge", p, c),
  },
  knowledge_listStudentKnowledgeSectionForClient: {
    /*
     * 学生知识点大章列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/knowledge/listStudentKnowledgeSectionForClient",
        p,
        c
      ),
  },
  knowledge_listSimple: {
    /*
     * 简易大章列表
     * courseId 课程id (integer query required)
     * section 大章名称 (string query )
     */
    get: (p, c) => $.get("/api/cms/resource/knowledge/listSimple", p, c),
  },
  knowledge_listSection: {
    /*
     * 简易大章列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/knowledge/listSection", p, c),
  },
  knowledge_listSKillTrainVideo: {
    /*
     * 技能培训知识点列表-视频
     */
    get: (p, c) =>
      $.get("/api/cms/resource/knowledge/listSKillTrainVideo", p, c),
  },
  knowledge_listSKillTrainSubject: {
    /*
     * 技能培训知识点列表-习题
     */
    get: (p, c) =>
      $.get("/api/cms/resource/knowledge/listSKillTrainSubject", p, c),
  },
  knowledge_listForClient: {
    /*
     * C端章节列表
     * courseId 课程id (integer query required)
     * type 类型：全部、视频、习题 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/knowledge/listForClient", p, c),
  },
  knowledge_listAdultExamKnowledge: {
    /*
     * 成考知识点列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/knowledge/listAdultExamKnowledge", p, c),
  },
  knowledge_listAdultEducationKnowledge: {
    /*
     * 成教知识点列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/knowledge/listAdultEducationKnowledge", p, c),
  },
  knowledge_exportAdultEducationKnowledge: {
    /*
     * 批量导出成教知识点
     */
    get: (p, c) =>
      $.get("/api/cms/resource/knowledge/exportAdultEducationKnowledge", p, c),
  },
  knowledge_batchRemove: {
    /*
     * 批量删除
     * ids 知识点id (array query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/knowledge/batchRemove", p, c),
  },

  /**
   * 选修课管理
   */
  elective: {
    /*
     * 编辑教学计划
     * bo  ( query required)
     */
    put: (p, c) => $.put("/api/cms/resource/elective", p, c),

    /*
     * 新增教学计划
     * bo  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/elective", p, c),

    /*
     * 删除教学计划
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/elective", p, c),
  },
  elective_setCurrentTimeRange: {
    /*
     * 设置当前选修课学期
     * timeRange 当前选修课学期 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/elective/setCurrentTimeRange", p, c),
  },
  elective_register: {
    /*
     * 学生报名
     * planId 教学计划id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/elective/register", p, c),
  },
  elective_cancel: {
    /*
     * 取消报名
     * planId 教学计划id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/elective/cancel", p, c),
  },
  elective_summaryForClient: {
    /*
     * 学生端选课汇总（已选总课时、学生最小/最大课时、所有标签及每个标签已选课时）
     */
    get: (p, c) => $.get("/api/cms/resource/elective/summaryForClient", p, c),
  },
  elective_schedule_list: {
    /*
     * 选修课排课列表
     */
    get: (p, c) => $.get("/api/cms/resource/elective/schedule/list", p, c),
  },
  elective_list: {
    /*
     * 管理端列表
     */
    get: (p, c) => $.get("/api/cms/resource/elective/list", p, c),
  },
  elective_listStudent: {
    /*
     * 选修课报名学生名单
     * planId 教学计划id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/elective/listStudent", p, c),
  },
  elective_listSimpleForTeacher: {
    /*
     * 选修课简易列表（排课下拉用）
     * teacherId 授课老师id (integer query required)
     * siteId 学校id (integer query required)
     * timeRange 学期 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/elective/listSimpleForTeacher", p, c),
  },
  elective_listByTagForClient: {
    /*
     * 学生端按标签课程列表（传入标签，返回该标签下的选修课列表及是否已选状态）
     * tag 课程标签 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/elective/listByTagForClient", p, c),
  },
  elective_getCurrentTimeRange: {
    /*
     * 获取当前选修课学期
     */
    get: (p, c) =>
      $.get("/api/cms/resource/elective/getCurrentTimeRange", p, c),
  },
  elective_detail: {
    /*
     * 学生端详情
     * planId 教学计划id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/elective/detail", p, c),
  },

  /**
   * 线下课表
   */
  courseTable_updateSchoolroom: {
    /*
     * 更新教室
     * id 课表id (integer query required)
     * schoolroomId 教室id (integer query required)
     * type 类型：全部、当前 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/resource/courseTable/updateSchoolroom", p, c),
  },
  courseTable_finish: {
    /*
     * 完成上课
     * ids id (array query required)
     */
    put: (p, c) => $.put("/api/cms/resource/courseTable/finish", p, c),
  },
  courseTable: {
    /*
     * 添加
     * table  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/courseTable", p, c),

    /*
     * 删除
     * id id (integer query required)
     * type 类型：当前，全部 (string query )
     */
    delete: (p, c) => $.delete("/api/cms/resource/courseTable", p, c),
  },
  courseTable_listTeachingPlanInfo: {
    /*
     * 排课教学计划情况
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/courseTable/listTeachingPlanInfo", p, c),
  },
  courseTable_confirm: {
    /*
     * 确认
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/courseTable/confirm", p, c),
  },
  courseTable_tableInfo: {
    /*
     * 排课信息
     * siteType 学校类型 (string query required)
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     * type 类型：标准，实时 (string query required)
     * start 开始时间，类型为实时的时候启用 (string query )
     * end 结束时间，类型为实时的时候启用 (string query )
     */
    get: (p, c) => $.get("/api/cms/resource/courseTable/tableInfo", p, c),
  },
  courseTable_tableInfoForStudent: {
    /*
     * 学生排课信息（课表）
     * schoolRollId 职教合同id (integer query required)
     * classId 班级id (integer query required)
     * term 学期 (integer query required)
     * start 开始时间 (string query required)
     * end 结束时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTable/tableInfoForStudent", p, c),
  },
  courseTable_tableInfoForClient: {
    /*
     * C端排课信息（课表）
     * start 开始时间 (string query required)
     * end 结束时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTable/tableInfoForClient", p, c),
  },
  courseTable_listWeekForAttendanceByStudent: {
    /*
     * 周考勤课表(学生)
     * classRoomId 班级id (integer query )
     * schoolRollId 学生id (integer query )
     * startTime 开始时间：周一0点 (string query required)
     * endTime 结束时间：周日23点59分59秒 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/courseTable/listWeekForAttendanceByStudent",
        p,
        c
      ),
  },
  courseTable_listTodayForAttendance: {
    /*
     * 当天考勤课表
     * classRoomId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTable/listTodayForAttendance", p, c),
  },
  courseTable_listSchoolroomInfo: {
    /*
     * 教室列表
     * classRoomId 班级id (integer query required)
     * startTime 开始时间 (string query required)
     * endTime 结束时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTable/listSchoolroomInfo", p, c),
  },
  courseTable_listForTeacher: {
    /*
     * 实时课表列表（讲师）
     */
    get: (p, c) => $.get("/api/cms/resource/courseTable/listForTeacher", p, c),
  },
  courseTable_listDayForAttendanceByStudent: {
    /*
     * 天考勤课表(学生)
     * classRoomId 班级id (integer query )
     * schoolRollId 学生id (integer query )
     * courseDate 日期（当天0点） (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/courseTable/listDayForAttendanceByStudent",
        p,
        c
      ),
  },

  /**
   * 课程
   */
  course_updateDiscipline: {
    /*
     * 编辑科类
     * id id (integer query required)
     * level 层次 (string query )
     * disciplines 科类列表 (array query required)
     */
    put: (p, c) => $.put("/api/cms/resource/course/updateDiscipline", p, c),
  },
  course: {
    /*
     * 添加
     * course  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/course", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/course", p, c),
  },
  course_listSkillTrain: {
    /*
     * 课程列表-技能培训
     */
    get: (p, c) => $.get("/api/cms/resource/course/listSkillTrain", p, c),
  },
  course_listSkillTrainForClient: {
    /*
     * C端课程列表-技能培训
     */
    get: (p, c) =>
      $.get("/api/cms/resource/course/listSkillTrainForClient", p, c),
  },
  course_listSimpleCourse: {
    /*
     * 简易课程列表
     * type 课程类型：成教，成考，继教院、技能培训 (string query required)
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) => $.get("/api/cms/resource/course/listSimpleCourse", p, c),
  },
  course_listSimpleAdultExamCourseForClient: {
    /*
     * C端简易成考课程列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/course/listSimpleAdultExamCourseForClient",
        p,
        c
      ),
  },
  course_listDiscipline: {
    /*
     * 科类列表
     * id id (integer query required)
     * level 层次 (string query )
     */
    get: (p, c) => $.get("/api/cms/resource/course/listDiscipline", p, c),
  },
  course_listContinueCourse: {
    /*
     * 继教院课程列表
     */
    get: (p, c) => $.get("/api/cms/resource/course/listContinueCourse", p, c),
  },
  course_listAdultExamCourse: {
    /*
     * 成考课程列表
     */
    get: (p, c) => $.get("/api/cms/resource/course/listAdultExamCourse", p, c),
  },
  course_listAdultExamCourseForClient: {
    /*
     * C端成考课程列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/course/listAdultExamCourseForClient", p, c),
  },
  course_listAdultEducationCourse: {
    /*
     * 成教课程列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/course/listAdultEducationCourse", p, c),
  },
  course_getIdByName: {
    /*
     * 通过名字获取id
     * type 课程类型：成教，成考，继教院、技能培训 (string query required)
     * province 省份-全部 (string query )
     * name 课程名字 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/course/getIdByName", p, c),
  },
  course_details: {
    /*
     * 课程详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/course/details", p, c),
  },
  course_detailsAdultExamCourseForClient: {
    /*
     * C端成考课程详情
     * id 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/course/detailsAdultExamCourseForClient", p, c),
  },

  /**
   * 学生试卷
   */
  studentPaper_createPaper: {
    /*
     * 创建试卷
     * paperId 顺序练习习题类型id (integer query required)
     * contentNum 由题干文章数量 (integer query required)
     * noContentNum 无题干题目数量 (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/studentPaper/createPaper", p, c),
  },
  studentPaper_listForClient: {
    /*
     * 试卷列表
     * paperId 顺序练习习题类型id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/studentPaper/listForClient", p, c),
  },

  /**
   * 学校课表
   */
  siteTable: {
    /*
     * 添加
     * siteTable  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/siteTable", p, c),
  },
  siteTable_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/resource/siteTable/list", p, c),
  },
  siteTable_listForElective: {
    /*
     * 选修课排课列表
     */
    get: (p, c) => $.get("/api/cms/resource/siteTable/listForElective", p, c),
  },
  siteTable_clear: {
    /*
     * 清除实时课表
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/siteTable/clear", p, c),
  },

  /**
   * 学校教学名单
   */
  sitePlanRoster: {
    /*
     * 添加
     * planId 教学计划id (integer query required)
     * schoolRollIds 合同id (array query required)
     * attendanceStatus 是否打卡 (string query required)
     */
    post: (p, c) => $.post("/api/cms/resource/sitePlanRoster", p, c),

    /*
     * 删除
     * planId 教学计划id (integer query required)
     * schoolRollIds 合同id (array query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/sitePlanRoster", p, c),
  },
  sitePlanRoster_upload: {
    /*
     * 导入（覆盖模式）
     * planId 教学计划id (integer query required)
     * classRoomId 班级id (integer query )
     * type 合同类型:自考，继教院 (string query required)
     * file 文件 (string body required)
     */
    post: (p, c) => $.post("/api/cms/resource/sitePlanRoster/upload", p, c),
  },
  sitePlanRoster_addToApp: {
    /*
     * 将未通过学生名单加入名称为自考app使用的教学计划（当前考期）
     * siteId 学校id (integer query required)
     * majorCourseId 专业课程 (integer query required)
     * courseId 课程id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/sitePlanRoster/addToApp", p, c),
  },
  sitePlanRoster_list: {
    /*
     * 简易列表
     * planId 教学计划id (integer query required)
     * classRoomId 班级id (integer query )
     */
    get: (p, c) => $.get("/api/cms/resource/sitePlanRoster/list", p, c),
  },
  sitePlanRoster_listUnJoined: {
    /*
     * 未添加进教学计划的名单简易列表
     * siteId 学校id (integer query required)
     * planId 教学计划id (integer query required)
     * classRoomId 班级id (integer query )
     */
    get: (p, c) => $.get("/api/cms/resource/sitePlanRoster/listUnJoined", p, c),
  },
  sitePlanRoster_listByStudent: {
    /*
     * 根据学生获取教学计划
     * schoolRollId 合同id (integer query required)
     * term 考期 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/sitePlanRoster/listByStudent", p, c),
  },
  sitePlanRoster_export: {
    /*
     * 简易列表导出
     * planId 教学计划id (integer query required)
     * classRoomId 班级id (integer query )
     */
    get: (p, c) => $.get("/api/cms/resource/sitePlanRoster/export", p, c),
  },
  sitePlanRoster_exportUnPassedStudent: {
    /*
     * 未通过学生列表导出
     * siteId 学校id (integer query required)
     * majorCourseId 专业id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/sitePlanRoster/exportUnPassedStudent", p, c),
  },

  /**
   * 自考试卷配置
   */
  selfPaperConfig_setConfig: {
    /*
     * 设置配置
     * courseId 课程id (integer query required)
     * type 试卷类型：模拟考试 (string query required)
     * content 配置的json字符串 (string query required)
     */
    post: (p, c) => $.post("/api/cms/resource/selfPaperConfig/setConfig", p, c),
  },
  selfPaperConfig_getConfig: {
    /*
     * 获取配置
     * courseId 课程id (integer query required)
     * type 试卷类型：模拟考试 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/selfPaperConfig/getConfig", p, c),
  },

  /**
   * 教室
   */
  schoolroom: {
    /*
     * 添加
     * schoolroom  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/schoolroom", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/schoolroom", p, c),
  },
  schoolroom_upload: {
    /*
     * 导入
     * siteId 学校id (integer query required)
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/cms/resource/schoolroom/upload", p, c),
  },
  schoolroom_listSimple: {
    /*
     * 教室简易列表
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/schoolroom/listSimple", p, c),
  },
  schoolroom_listRegin: {
    /*
     * 区域列表
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/schoolroom/listRegin", p, c),
  },
  schoolroom_listForContinue: {
    /*
     * 继教院教室列表
     */
    get: (p, c) => $.get("/api/cms/resource/schoolroom/listForContinue", p, c),
  },
  schoolroom_exportForContinue: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/cms/resource/schoolroom/exportForContinue", p, c),
  },

  /**
   * 试卷
   */
  paper: {
    /*
     * 添加
     * paper  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/paper", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/paper", p, c),
  },
  paper_uploadSubject: {
    /*
     * 上传试卷习题
     * id 试卷id (integer query required)
     * attach 附件地址 (string query required)
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/cms/resource/paper/uploadSubject", p, c),
  },
  paper_uploadSubjectByExcel: {
    /*
     * 上传试卷习题-Excel模式
     * id id (integer query required)
     * attachUrl 试卷源文件地址 (string query required)
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/paper/uploadSubjectByExcel", p, c),
  },
  paper_uploadSortSubject: {
    /*
     * 上传顺序练习习题
     * courseId 课程id (integer query required)
     * paperName 顺序练习试卷名称 (string query required)
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/cms/resource/paper/uploadSortSubject", p, c),
  },
  paper_uploadSortSubjectByExcel: {
    /*
     * 上传顺序练习习题-Excel模式
     * courseId 课程id (integer query required)
     * paperName 顺序练习试卷名称 (string query required)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/paper/uploadSortSubjectByExcel", p, c),
  },
  paper_testPaperForClient: {
    /*
     * C端试卷(摸底考试)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/testPaperForClient", p, c),
  },
  paper_listStudentTestPaperDetail: {
    /*
     * 具体成绩列表-学历教育-成考管理-成考摸底详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/paper/listStudentTestPaperDetail", p, c),
  },
  paper_listSkillTrainMockPaper: {
    /*
     * 模拟测试列表-技能培训
     */
    get: (p, c) =>
      $.get("/api/cms/resource/paper/listSkillTrainMockPaper", p, c),
  },
  paper_listSimple: {
    /*
     * 试卷简易列表
     * type 试卷类型：历年真题，模拟测试，摸底考试 (string query required)
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listSimple", p, c),
  },
  paper_listPastRealPaper: {
    /*
     * 历年真题列表
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listPastRealPaper", p, c),
  },
  paper_listPaper: {
    /*
     * 试卷(历年真题和模拟测试)列表
     * type 试卷类型：历年真题，模拟测试，摸底考试，社会生摸底考试 (string query required)
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listPaper", p, c),
  },
  paper_listPaperForMainPage: {
    /*
     * 首页试卷(历年真题,模拟测试,摸底考试)列表
     * type 试卷类型：历年真题，模拟测试，摸底考试 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listPaperForMainPage", p, c),
  },
  paper_listPaperForClient: {
    /*
     * C端试卷(历年真题,模拟测试,摸底考试，社会生摸底考试，顺序练习)列表
     * type 试卷类型：历年真题，模拟测试，顺序练习 (string query required)
     * courseId 课程id (integer query )
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listPaperForClient", p, c),
  },
  paper_listName: {
    /*
     * 试卷名称列表
     * courseId 课程id (integer query required)
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listName", p, c),
  },
  paper_listMockTestPaper: {
    /*
     * 模拟测试列表
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listMockTestPaper", p, c),
  },
  paper_listHabitTestPaper: {
    /*
     * 摸底考试列表
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listHabitTestPaper", p, c),
  },
  paper_listAdultExamStudentTestPaper: {
    /*
     * 列表-学历教育-成考管理-成考摸底详情
     */
    get: (p, c) =>
      $.get("/api/cms/resource/paper/listAdultExamStudentTestPaper", p, c),
  },
  paper_exportAdultExamStudentTestPaper: {
    /*
     * 导出-学历教育-成考管理-成考摸底详情
     */
    get: (p, c) =>
      $.get("/api/cms/resource/paper/exportAdultExamStudentTestPaper", p, c),
  },

  /**
   * 成考直播课
   */
  liveCourse: {
    /*
     * 添加
     * liveCourse  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/liveCourse", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/liveCourse", p, c),
  },
  liveCourse_listSimple: {
    /*
     * 直播课简易列表
     * courseType 课程类别 (string query required)
     * liveCourseType 类别：公开课 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/liveCourse/listSimple", p, c),
  },
  liveCourse_listAdultExamLiveCourse: {
    /*
     * 成考直播课程列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/liveCourse/listAdultExamLiveCourse", p, c),
  },
  liveCourse_listAdultExamLiveCoursePlaybackForClient: {
    /*
     * 根据课程id获取成考直播课程
     * type 类别：公开课 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/liveCourse/listAdultExamLiveCoursePlaybackForClient",
        p,
        c
      ),
  },
  liveCourse_listAdultExamLiveCourseForClient: {
    /*
     * C端成考直播课程列表
     * type 类别：公开课 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/liveCourse/listAdultExamLiveCourseForClient",
        p,
        c
      ),
  },
  liveCourse_detailsAdultExamLiveCourseForClient: {
    /*
     * C端成考课程详情
     * id 直播课程id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/liveCourse/detailsAdultExamLiveCourseForClient",
        p,
        c
      ),
  },

  /**
   * 成考直播章节
   */
  liveCourseChapter: {
    /*
     * 添加
     * liveCourseChapter  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/liveCourseChapter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/liveCourseChapter", p, c),
  },
  liveCourseChapter_listSimple: {
    /*
     * 简易列表
     * liveCourseId 直播课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/liveCourseChapter/listSimple", p, c),
  },
  liveCourseChapter_listSection: {
    /*
     * 简易大章列表
     * liveCourseId 直播课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/liveCourseChapter/listSection", p, c),
  },
  liveCourseChapter_listPassedForClient: {
    /*
     * 回放列表（需要登录）
     * liveCourseId 直播课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/liveCourseChapter/listPassedForClient", p, c),
  },
  liveCourseChapter_listAdultExamLiveCourseChapter: {
    /*
     * 成考直播章节列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/liveCourseChapter/listAdultExamLiveCourseChapter",
        p,
        c
      ),
  },

  /**
   * 选修课课时配置
   */
  electiveClassHourConfig_set: {
    /*
     * 设置选修课学生课时配置（operateType：添加/修改/删除/清空）
     * config  ( query required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/electiveClassHourConfig/set", p, c),
  },
  electiveClassHourConfig_list: {
    /*
     * 获取选修课学生课时配置列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/electiveClassHourConfig/list", p, c),
  },

  /**
   * 电子书
   */
  ebook: {
    /*
     * 添加编辑
     * ebook  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/ebook", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/ebook", p, c),
  },
  ebook_listSimple: {
    /*
     * 简易电子书列表
     * type 类型：成教 (string query required)
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) => $.get("/api/cms/resource/ebook/listSimple", p, c),
  },
  ebook_listForAdult: {
    /*
     * 成教电子书列表
     */
    get: (p, c) => $.get("/api/cms/resource/ebook/listForAdult", p, c),
  },
  ebook_exportForAdult: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/resource/ebook/exportForAdult", p, c),
  },
  ebook_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/ebook/details", p, c),
  },

  /**
   * 课表模板
   */
  courseTableTemplate: {
    /*
     * 添加
     * template  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/courseTableTemplate", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/courseTableTemplate", p, c),
  },
  courseTableTemplate_listName: {
    /*
     * 模板名称列表
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTableTemplate/listName", p, c),
  },
  courseTableTemplate_listForContinue: {
    /*
     * 继教院课表模板列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTableTemplate/listForContinue", p, c),
  },
  courseTableTemplate_listForContinueByDomain: {
    /*
     * 继教院课表模板列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/courseTableTemplate/listForContinueByDomain",
        p,
        c
      ),
  },
  courseTableTemplate_listByName: {
    /*
     * 课表列表
     * name 模板名字 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTableTemplate/listByName", p, c),
  },

  /**
   * 继教院教学计划
   */
  continueTeachingPlan: {
    /*
     * 添加
     * plan  ( query required)
     */
    post: (p, c) => $.post("/api/cms/resource/continueTeachingPlan", p, c),

    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/continueTeachingPlan", p, c),
  },
  continueTeachingPlan_uploadForSite: {
    /*
     * 导入（学校教学计划）
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/continueTeachingPlan/uploadForSite", p, c),
  },
  continueTeachingPlan_uploadForClassRoom: {
    /*
     * 导入（班级教学计划）
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/continueTeachingPlan/uploadForClassRoom", p, c),
  },
  continueTeachingPlan_uploadForClassRoomByDomain: {
    /*
     * 导入（班级教学计划）
     * file  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/cms/resource/continueTeachingPlan/uploadForClassRoomByDomain",
        p,
        c
      ),
  },
  continueTeachingPlan_listTerm: {
    /*
     * 学期列表表（班级）
     * classRoomId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listTerm", p, c),
  },
  continueTeachingPlan_listTeacher: {
    /*
     * 讲师列表表（班级）
     * classRoomId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listTeacher", p, c),
  },
  continueTeachingPlan_listSiteForSiteByTeacher: {
    /*
     * 简易列表（学校）（讲师）
     * timeRange 时间 (string query required)
     * teacherId 讲师id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listSiteForSiteByTeacher",
        p,
        c
      ),
  },
  continueTeachingPlan_listSimple: {
    /*
     * 简易列表（班主任）（班级）
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listSimple", p, c),
  },
  continueTeachingPlan_listSimpleSite: {
    /*
     * 简易列表（学校）
     * siteId 学校id (integer query required)
     * courseId 课程id (integer query required)
     * term 考期 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listSimpleSite", p, c),
  },
  continueTeachingPlan_listSimpleSiteForTeacher: {
    /*
     * 简易列表（学校）
     * siteId 学校id (integer query required)
     * timeRange 时间 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listSimpleSiteForTeacher",
        p,
        c
      ),
  },
  continueTeachingPlan_listSimpleForTeacher: {
    /*
     * 简易列表（班级）
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listSimpleForTeacher",
        p,
        c
      ),
  },
  continueTeachingPlan_listSimpleForSiteByTeacher: {
    /*
     * 简易列表（教学计划）（讲师）
     * timeRange 时间 (string query required)
     * siteId 学校id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listSimpleForSiteByTeacher",
        p,
        c
      ),
  },
  continueTeachingPlan_listForSite: {
    /*
     * 列表（学校教学计划）
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listForSite", p, c),
  },
  continueTeachingPlan_listForClassRoom: {
    /*
     * 列表（班级教学计划）
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listForClassRoom", p, c),
  },
  continueTeachingPlan_listForClassRoomByDomain: {
    /*
     * 列表（班级教学计划）-根据学校域名
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listForClassRoomByDomain",
        p,
        c
      ),
  },
  continueTeachingPlan_listByClassRoomAndTerm: {
    /*
     * 根据班级和学期获取简易列表表（班级）
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listByClassRoomAndTerm",
        p,
        c
      ),
  },
  continueTeachingPlan_exportForSite: {
    /*
     * 导出（学校教学计划）
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/exportForSite", p, c),
  },
  continueTeachingPlan_exportForClassRoom: {
    /*
     * 导出（班级教学计划）
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/exportForClassRoom", p, c),
  },
  continueTeachingPlan_exportForClassRoomByDomain: {
    /*
     * 导出（班级教学计划）-根据学校域名
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/exportForClassRoomByDomain",
        p,
        c
      ),
  },

  /**
   * 班级课表
   */
  classCourseTable_init: {
    /*
     * 初始化
     * batch 批次 (string query required)
     * siteType 学校类型：继教院 (string query required)
     * siteIds 学校id (array query )
     * term 学期 (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/classCourseTable/init", p, c),
  },
  classCourseTable_initByDomain: {
    /*
     * 初始化-根据学校域名
     * batch 批次 (string query required)
     * siteType 学校类型：继教院 (string query required)
     * term 学期 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/classCourseTable/initByDomain", p, c),
  },
  classCourseTable_listForContinue: {
    /*
     * 继教院班级课表列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/classCourseTable/listForContinue", p, c),
  },
  classCourseTable_listForContinueByDomain: {
    /*
     * 继教院班级课表列表-根据学校域名
     */
    get: (p, c) =>
      $.get("/api/cms/resource/classCourseTable/listForContinueByDomain", p, c),
  },
  classCourseTable_clear: {
    /*
     * 清空实时课表
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/resource/classCourseTable/clear", p, c),
  },
};
